namespace Portico.Models {

    export class SessionDetail {
        public expirationDate: Date;
        public status: string;
        public features: string[];
        public isParent: boolean;
        public parentPortalId: string;
        public userName: string;

        constructor(obj?: any) {
            this.expirationDate = new Date();
            this.status = 'active';
            this.features = [];
            this.parentPortalId = null;
            this.userName = null;

            if (obj) {
                this.expirationDate = obj.expirationDate !== null ? new Date(obj.expirationDate) : new Date();
                this.status = obj.status || null;
                this.features = obj.features || null;
                this.isParent = obj.isParent || false;
                this.userName = obj.userName || null;
            }
        }
    }
}